import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";

const Home1Page = lazy(() => import("../app/components/home/index"));
const Home2Page = lazy(() => import("../app/components/home/index2"));
const Home3Page = lazy(() => import("../app/components/home/index3"));
const Home4Page = lazy(() => import("../app/components/home/index4"));
const AboutUsPage = lazy(() => import("../app/components/misc/about-us"));
const ContactPage = lazy(() => import("../app/components/misc/contact-us"));
const FaqPage = lazy(() => import("../app/components/misc/faq"));
const GlossaryPage = lazy(() => import("../app/components/misc/glossary"));
const PrivacyPolicyPage = lazy(() => import("../app/components/misc/privacy-policy"));
const TermsConditionsPage = lazy(() => import("../app/components/misc/terms-conditions"));
const Error404Page = lazy(() => import("../app/components/misc/error404"));
const BlogGridPage = lazy(() => import("../app/components/blogs/blog-grid"));
const BlogsDetailPage = lazy(() => import("../app/components/blogs/blog-detail"));
const Services1Page = lazy(() => import("../app/components/services/services1"));
const Services2Page = lazy(() => import("../app/components/services/services2"));
const ServicesDetailPage = lazy(() => import("../app/components/services/services-detail"));
const B2CBrandLaunchPage = lazy(() => import("../app/components/services/b2c-brand-launch"));
const RetailerRolloutPage = lazy(() => import("../app/components/services/retailer-rollout"));
const HolidayPeakManagementPage = lazy(() => import("../app/components/services/holiday-peak-management"));
const MultiChannelExpansionPage = lazy(() => import("../app/components/services/multi-channel-expansion"));
const RapidCustomerOnboardingPage = lazy(() => import("../app/components/services/rapid-customer-onboarding"));
const CrisisRecoveryPage = lazy(() => import("../app/components/services/crisis-recovery"));
const LocationsPage = lazy(() => import("../app/components/misc/locations"));
const RemoteHelpPage = lazy(() => import("../app/components/misc/remote-help"));

function AppRoutes() {
    return (
        <Suspense fallback={
            <div className="loading-area">
                <div className="loading-box" />
                <div className="loading-pic">
                    <div id="outer-barG">
                        <div id="front-barG" className="bar-animationG">
                            <div id="barG_1" className="bar-lineG" />
                            <div id="barG_2" className="bar-lineG" />
                            <div id="barG_3" className="bar-lineG" />
                        </div>
                    </div>
                </div>
            </div>
        }>
            <Routes>
                <Route path='/' element={<Home4Page />} />
                <Route path='/index' element={<Home1Page />} />
                <Route path='/index2' element={<Home2Page />} />
                <Route path='/index3' element={<Home3Page />} />
                <Route path='/index4' element={<Home4Page />} />
                <Route path='/about-us' element={<AboutUsPage />} />
                <Route path='/locations' element={<LocationsPage />} />
                <Route path='/faq' element={<FaqPage />} />
                <Route path='/3pl-glossary' element={<GlossaryPage />} />
                <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
                <Route path='/terms-conditions' element={<TermsConditionsPage />} />
                <Route path='/error404' element={<Error404Page />} />
                <Route path='/services' element={<Services1Page />} />
                <Route path='/services/services1' element={<Services1Page />} />
                <Route path='/services/services2' element={<Services2Page />} />
                <Route path='/services/detail' element={<ServicesDetailPage />} />
                <Route path='/services/B2C-brand-launch' element={<B2CBrandLaunchPage />} />
                <Route path='/services/retailer-rollout' element={<RetailerRolloutPage />} />
                <Route path='/services/holiday-peak-management' element={<HolidayPeakManagementPage />} />
                <Route path='/services/multi-channel-expansion' element={<MultiChannelExpansionPage />} />
                <Route path='/services/rapid-customer-onboarding' element={<RapidCustomerOnboardingPage />} />
                <Route path='/services/crisis-recovery' element={<CrisisRecoveryPage />} />
                <Route path='/news' element={<BlogGridPage />} />
                <Route path='/news/grid' element={<BlogGridPage />} />
                <Route path='/news/detail' element={<BlogsDetailPage />} />
                <Route path='/contact-us' element={<ContactPage />} />
                <Route path='/remote-help' element={<RemoteHelpPage />} />
                <Route path='*' element={<Error404Page/>} />
                <Route element={<Error404Page/>} />
            </Routes>
        </Suspense>
    )
}

export default AppRoutes;
